// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"5d7897dd","161":"52f5d3da","166":"a81456ec","722":"5228942e","821":"e3c11ce5","963":"4877fcca"}[chunkId] + ".chunk.js";
};